import React from 'react';
import { CloseButton, JustifyDiv } from './styles'
import { Icon } from 'bd-web-components';
import { PRIMARY_BLUE_03 } from 'bd-web-components/src/utils/dash-colors';

const UseTerms: any = ({ setIsOpen }: any) => {
  const handleClose = () => {
    setIsOpen(false)
  }

  const createParagraph = ((number: string) => (<>&nbsp;&nbsp;<strong>{number}</strong> - </>))
  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px'
      }}>
        <h2>{'Termo e Condições de Uso do Saque'}</h2>
        <CloseButton
          // @ts-ignore
          onClick={handleClose}
                type="button"
              >
                <Icon
                  width={16}
                  height={16}
                  iconName={'x'}
                  fill={PRIMARY_BLUE_03}
                  classes="add-account-chevron"
                />
              </CloseButton>
      </div>
    <JustifyDiv>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;O presente Termo de Uso e Condições (Termo) apresenta as condições gerais aplicáveis ao uso dos serviços previstos no contrato celebrado entre a BILHETERIA DIGITAL PROMOÇÃO E ENTRETENIMENTO LTDA., doravante denominado(a) “BD” e  PRODUTOR(A), por si ou representado(a) por seu representante legal, devidamente nominado(a) e qualificado(a) nas Ordens  de  Serviços  anexas,  doravante  denominado(a)  “PRODUTOR(A)”,  cujo  objeto  é  a Prestação de Serviços de Reserva e Venda de Ingressos por meio da Plataforma de Anúncios do Portal www.bilheteriadigital.com, em caráter não transferível, referente ao(s) evento(s) estabelecidos nas Ordens de Serviços e Formulário(s) de Implantação de Evento(s).
      </p>
      <br/>
      <h3>1. CONSIDERAÇÕES INICIAIS </h3>
      <br/>
      <p>
        {createParagraph('1.1')}A BD desenvolveu um software especializado na criação de sistemas de visualização e integração de dados para o anúncio de eventos com o fim de promover a comercialização de ingressos por meio do Portal <strong>www.bilheteriadigital.com</strong>, contendo uma Plataforma de Anúncios, doravante denominados SISTEMAS BD.
      </p>
      <br/>
      <p>
        {createParagraph('1.2')}O <strong>PRODUTOR(A)</strong> exerce as atividades de planejar, organizar, promover e acompanhar eventos JustifyDiversos e festas, operando a infraestrutura dos lugares onde ocorrem esses eventos, elaborando projeto dos eventos, desenvolvendo o plano de marketing e divulgação; selecionando pessoas para trabalhar em seus eventos e sendo responsável pelos imprevistos antes e durante os eventos;
      </p>
      <br/>
      <p>
        {createParagraph('1.3')}A BD não é fornecedora de quaisquer produtos ou serviços anunciados no Portal <strong>www.bilheteriadigital.com</strong>, razão pela qual não possui qualquer responsabilidade pela organização e/ou execução dos eventos anunciados.
      </p>
      <br/>
      <p>
        {createParagraph('1.4')}A BD apenas presta um serviço consistente na oferta de uma plataforma na internet que fornece espaços para que o<strong>(a) PRODUTOR(A)</strong> anuncie, oferecendo à venda, os seus próprios eventos e festas para que eventuais interessados na compra dos eventos, os Usuários /potenciais compradores, possam negociar direta e exclusivamente entre si;
      </p>
      <br/>
      <p>
        {createParagraph('1.5')}O<strong>(A) PRODUTOR(A)</strong>, ao utilizar a Painel de Gestão presente no Portal <strong>www.bilheteriadigital.com</strong>, aderirá automaticamente aos Termos de Uso e à Política de Privacidade do site da BD, no que diz respeito ao complexo de programas e softwares de processamentos de dados cujo uso e acesso ao portal é licenciado aos Usuários/Produtores/Licenciados, contendo softwares de ingressos, referente a este Contrato e a quaisquer outros adendos e Ordens de Serviços.
      </p>
      <br/>
      <p>
        {createParagraph('1.6')}Portal: É o Site “www.bilheteriadigital.com” que contém a Plataforma de Anúncios do(s) evento(s) do(a) PRODUTOR(A).
      </p>
      <br/>
      <p>
        {createParagraph('1.7')}Sistemas Bilheteria Digital / Softwares: É o complexo de programas e softwares de processamentos de dados, contendo softwares de ingressos, devidamente disponibilizados no Portal.
      </p>
      <br/>
      <p>
        {createParagraph('1.8')}Painel de Acesso do(a) PRODUTOR(A): É o acesso do(a) PRODUTOR(A) no Portal www.bilheteriadigital.com para a emissão de relatórios de acompanhamento das vendas dos ingressos do(s) evento(s), tais como Relatórios Gerenciais e Financeiros. O Painel de Acesso é regulamentado pelos Termos de Uso e Política de Privacidade constantes no site.
      </p>
      <br/>
      <h3>2. PROCESSAMENTO DE PAGAMENTOS E TRANSFERÊNCIAS DE VALORES </h3>
      <br/>
      <p>
      {createParagraph('2.1')}Como previsto no contrato, ao contratar a BD para a prestação de serviços de reserva e venda de ingressos por meio deste Contrato ou Ordens de Serviços, o<strong>(a) PRODUTOR(A)</strong> outorgou, um Mandato Irrevogável de Transferência de Dinheiro para que a BD dê ao dinheiro a devida destinação de acordo com o contrato firmado entre as partes, agindo por conta e ordem, sempre escrita, do<strong>(a) PRODUTOR(A)</strong>.
      </p>
      <br/>
      <p>
      {createParagraph('2.2')}O Mandato outorgado pelo<strong>(a) PRODUTOR(A)</strong> implica em uma autorização à BD para:
      </p>
      <br/>
        <aside
          style={{
            width: '100%',
            paddingLeft: '40px',
            float: 'right',
            fontStyle: 'italic'
          }}
        >
          <p>
            {createParagraph('2.2.1')}Dispor em seu nome de todo e qualquer dinheiro creditado na  Conta Fechamento Virtual ou Conta Gráfica da Intermediadora (Pagseguro ou outra) dos ingressos  comercializados  no(s)  evento(s)  anunciados  para  transferi-lo(s) ao(aos) Produtor(es) Destinatário(s); Fornecedor(es) e Artista(s), tudo conforme requerimentos, sempre escrito, do(a) PRODUTOR(A) e/ou dos Consumidores em caso de cancelamento ou dentro do prazo do direito de arrependimento. 
          </p>
          <br/>
          <p>
            {createParagraph('2.2.3')}Debitar  do  valor  efetivamente  recebido  pela  reserva  e  venda  dos ingressos:  (i)  os  percentuais  de  contraprestações  oriundos  das  Ordens  de Serviços  e  (ii)  toda  e  qualquer  quantia  proveniente  de  direitos;  obrigações; multas  e  descumprimentos  definidos  neste  Contrato,  mediante  posterior prestação de contas por escrito. 
          </p>
          <br/>
          <p>
            {createParagraph('2.2.3')}Realizar  a  retenção  de  todo  e  qualquer  dinheiro  creditado  na  Conta Fechamento Virtual ou Conta Gráfica da Intermediadora até no máximo 10 (dez) dias  úteis  após  o  fechamento  do(s)  evento(s)  para  fins  de  atendimento  ao disposto nas cláusulas 6.2.3, 8.5  e 11.7 do Contrato de Prestação de Serviços de Reserva e Venda de Ingressos por meio da Plataforma de Anúncios do Portal www.bilheteriadigital.com, assim como para quitação de dívidas pretéritas do PRODUTOR(A).
          </p>
          <br/>
        </aside>
      <p>
        {createParagraph('2.3')}As retiradas de dinheiro das reservas e vendas online disponíveis na Conta Fechamento Virtual ou Conta Gráfica da Intermediadora serão realizadas por meio de transferência bancária da Conta  da  Intermediadora para a  Conta Bancária (corrente ou poupança)  indicada pelo(a) PRODUTOR(A) nos termos da cláusula 2.4, descontadas as taxas e valores devidos para a BD.
      </p>
      <br/>
      <p>
        {createParagraph('2.4')}Considerando  a  necessidade  de  conciliação  bancária  entre  os  valores  que  são disponibilizadas  a  partir  das  reservas  e  vendas  online  e  os  valores  repassados  para  o(a) PRODUTOR(A), as PARTES ajustam que toda e qualquer transferência bancária deverá ser realizada para Conta(s) Bancária(s) (corrente ou poupança) indicada por conta, ordem e risco pelo(a) PRODUTOR(A) através do portal eletrônico da BD.
      </p>
      <br/>
      <p>
        {createParagraph('2.5')}A transferência prevista no item 2.3 ocorrerá de acordo com a proposta enviada pela BD, sendo que qualquer custo originado pela retirada correrá às custas do(a) PRODUTOR(A).
      </p>
      <br/>
      <p>
      {createParagraph('2.6')}O PRODUTOR(A) poderá visualizar todos os pagamentos depositados em sua Conta Virtual por meio da Plataforma da BD.
      </p>
      <br/>
      <p>
      {createParagraph('2.7')}Caso a transferência seja impossibilitada por motivo de força maior e/ou caso fortuito, não estará configurado o inadimplemento da BD.
      </p>
      <br/>
      <p>
      {createParagraph('2.8')}O  PRODUTOR(A)  isenta  a  BD  de  qualquer  responsabilidade  em  relação  às transferências  incorretas  ou  malsucedidas  decorrentes  do  fornecimento  indevido  de informações,  cabendo  ao PRODUTOR(A) solicitar novo repasse a  partir  da indicação dos dados corretos no sistema da BD.
      </p>
      <br/>
      <p>
      {createParagraph('2.9')}O PRODUTOR(A) declara-se ciente de que, uma vez transferidos os valores da Conta Fechamento Virtual ou Conta Gráfica da Intermediadora, de acordo com as instruções dadas pelo Usuário,  tais  pagamentos  são  definitivos  e  irreversíveis,  isentando  a  BD  de  qualquer responsabilidade.
      </p>
      <br/>
      <p>
      {createParagraph('2.10')}Em caso de necessidade de alteração da conta previamente informada, a BD deverá ser informada pelo PRODUTOR(A) em um prazo máximo de 24 (vinte e quatro) horas antes do prazo do repasse.
      </p>
      <br/>
      <p>
      {createParagraph('2.11')}Os valores depositados na Conta Fechamento Virtual ou Conta Gráfica da Intermediadora não  sofrerão  qualquer  correção  monetária,  qualquer  tipo  de  atualização  ou  remuneração financeira,  permanecendo  inalterados  por  todo  o  prazo  em  que  forem  mantidos, independentemente do tempo que o PRODUTOR(A) demore a solicitar a transferência dos valores  para  a  sua  Conta  Bancária,  sendo  a  BD  isenta  de  qualquer  responsabilidade,  por eventual perda de poder aquisitivo ou desvalorização monetária.
      </p>
      <br/>
      <p>
      {createParagraph('2.12')}Caso a BD receba um Chargeback da Operadora de Cartão de Crédito, será debitado da Conta Virtual do PRODUTOR(A) o valor recebido pela venda ou sua por comissão.
      </p>
      <br/>
      <p>
      {createParagraph('2.13')}Para  evitar  Chargebacks,  é  aconselhável  que  o  PRODUTOR(A)  mantenha  boas práticas  comerciais,  como  fornecer  informações  claras  e  objetivas  sobre  seus  produtos, conservar  os  comprovantes  das  transações  realizadas  e  manter  políticas  claras  de cancelamento e restituição.
      </p>
      <br/>
      <p>
      {createParagraph('2.14')}São  causas  de  Chargebacks:  (I)  o  direito  de  arrependimento  do  Comprador  ou  sua insatisfação com a compra; (II) não recebimento pelo Comprador dos itens da compra, nas condições  estabelecidas  para  a  entrega;  (III)  dúvidas  do  Comprador  sobre  a  validade  da compra; (IV) débitos duplicados do Comprador sobre uma única compra; e (v) compra de terceiro não autorizado com a utilização do cartão de crédito do Comprador.
      </p>
      <br/>
      <p>
      {createParagraph('2.15')}O PRODUTOR(A) autoriza e aceita que a BD desconte de sua Conta Virtual todo e qualquer  valor  decorrente  de  ações  judiciais  e/ou  administrativas,  incluindo  honorários advocatícios, honorários de sucumbência, custas processuais, pagas pela BD, ocasionados pela comercialização  dos  produtos  e/ou  serviços  pelo  PRODUTOR(A),  assim  como  autoriza  e aceita que a BD faça as retenções previstas nas cláusulas  6.2.3,  8.5  e 11.7 do Contrato de Prestação de Serviços de Reserva e Venda de Ingressos por meio da Plataforma de Anúncios do  Portal  www.bilheteriadigital.com,  assim  como  para  quitação  de  dívidas  pretéritas  do PRODUTOR(A).  2.16. É reservado à BD o direito de não autorizar ou realizar qualquer transação que entenda violar o presente Termo.
      </p>
      <br/>




      <h3>3. CLÁUSULAS GERAIS</h3>
      <br/>
      <p>
        {createParagraph('3.1')}O Usuário não poderá utilizar a Plataforma para desenvolver atividades ou comercializar bens e/ou serviços não autorizados por lei ou em desacordo com a política da BD.
      </p>
      <br/>
      <p>
      {createParagraph('3.2')}A BD não se responsabiliza por falhas de sistema, causados por eventos de força maior ou caso fortuito, assim como por invasões realizadas por “Hackers”, que atrasem ou impeça a realização de transações em sua plataforma.  
      </p>
      <br/>
      <p>
      {createParagraph('3.3')}A BD não  se responsabiliza pelas obrigações tributárias decorrentes das transações realizadas  entre  PRODUTOR(A)  e/ou  Afiliados  e  Compradores,  cabendo  única  e exclusivamente  ao  PRODUTOR(A)  o  recolhimento  e/ou  retenção  de  eventuais  valores devidos à Fazenda Municipal, Estadual ou Federal.  
      </p>
      <br/>
      <p>
      {createParagraph('3.4')}O(a) PRODUTOR(A) declara conhecer as normas de prevenção à corrupção previstas na legislação brasileira, dentre elas o Código Penal, a Lei de Improbidade Administrativa (Lei nº 8.429/92) e a Lei nº 12.846/13 e seus regulamentos, comprometem-se a cumpri-las fielmente, por e seus sócios, administradores e colaboradores, bem como exigir o seu cumprimento pelos terceiros por elas contratados. 
      </p>
      <br/>
      <p>
      {createParagraph('3.5')}O(a) PRODUTOR(A) obriga-se a, no exercício dos direitos e obrigações previstos neste Termo e no cumprimento de qualquer uma de suas disposições do Contrato de Prestação de Serviços de Reserva e Venda de Ingressos por meio da Plataforma de Anúncios do Portal www.bilheteriadigital.com  celebrado  entre  as  partes:  (i)  não  dar,  oferecer  ou  prometer qualquer bem de valor ou vantagem de qualquer natureza a agentes públicos ou a pessoas a eles relacionadas ou ainda quaisquer outras pessoas, empresas e/ou entidades privadas, com o  objetivo  de  obter  vantagem indevida,  influenciar  ato  ou  decisão  ou  direcionar  negócios ilicitamente e (ii) adotar as melhores práticas de monitoramento e verificação do cumprimento das Leis Anticorrupção, com o objetivo atos de prevenir atos de corrupção, fraude, práticas ilícitas ou lavagem de dinheiro por seus sócios, administradores e colaboradores ou terceiros por ela contratados.
      </p>
      <br/>
      <p>
      {createParagraph('3.6')}O(a) PRODUTOR(A) tem ciência e autoriza, desde já, que a BD forneça qualquer tipo de informação financeira a uma autoridade governamental em decorrência de atendimento a exigência legal e/ou de ordem judicial ou administrativa.
      </p>
      <br/>
      <p>
      {createParagraph('3.7')}O presente termo de uso terá a mesma vigência do Contrato de Prestação de Serviços de  Reserva  e  Venda  de  Ingressos  por  meio  da  Plataforma  de  Anúncios  do  Portal www.bilheteriadigital.com celebrado entre as partes.
      </p>
      <br/>
      <p>
      {createParagraph('3.8')}Fica eleito o Foro da Circunscrição Judiciária da Capital do Estado de São Paulo, para dirimir qualquer litígio que possa advir o presente Contato, com renúncia a qualquer outro, por mais privilegiado que seja.
      </p>
      <br/>
      </JustifyDiv>
    </div>
  );
};

export default UseTerms;
